import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import mnjson from 'i18/translations/mn.json';
import kojson from 'i18/translations/ko.json';
import enjson from 'i18/translations/en.json';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            mn: { translation: mnjson },
            ko: { translation: kojson },
            en: { translation: enjson },
        },
        lng: 'mn',
        fallbackLng: 'mn',
        debug: false,
        detection: {
            order: ['cookie', 'localStorage'],
            caches: ['cookie', 'localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;